import React, { useState } from "react";
import loader from "../assets/images/videoloader.gif"; // 👈 your GIF

function VideoWithImage({ videoSrc, className }) {
    const [loading, setLoading] = useState(true);

    return (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
            {/* Show image until video loads */}
            {loading && (
                <img
                    src={loader}
                    alt="loading..."
                    style={{
                        width: "50%",
                        height: "50%",
                        objectFit: "cover",
                        position: "absolute",
                        inset: 0,
                        zIndex: 1,
                        top: "20%",
                        left: "30%"
                    }}
                />
            )}

            {/* Video */}
            <video
                className={className}
                autoPlay
                playsInline
                muted
                loop
                onLoadedData={() => setLoading(false)}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "fill",
                    opacity: loading ? 0 : 1,
                    transition: "opacity 0.5s ease-in-out",
                }}
            >
                <source src={videoSrc} />
            </video>
        </div>
    );
}

export default VideoWithImage;
